module.exports = __webpack_public_path__ + "static/media/volume-slash.75a2ed0c.svg";